module.exports = __webpack_public_path__ + "static/media/foodshot31.5402e8cb.JPG";